export default "__VITE_ASSET__COKTVEVi__"